import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Checkbox/CheckboxAnatomy.mdx";
import Usage from "../../Docs/Components/Checkbox/CheckboxUsage.mdx";

import Examples from "../../Docs/Components/Checkbox/CheckboxExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Checkbox"
            description="In a list of one or more items, checkboxes are used when none, one or multiple options can be selected."
            apiSources={["azure-devops-ui/Components/Checkbox/Checkbox.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;